import { render, staticRenderFns } from "./FloatingButton.vue?vue&type=template&id=337a0c6d&"
import script from "./FloatingButton.vue?vue&type=script&lang=js&"
export * from "./FloatingButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VSwitch})
